import '@jh3y/whirl/css/traditional.css';

// ** React Imports
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// ** Redux Imports
import { Provider } from 'react-redux';
import { store, persistor } from '@store/storeConfig/store';
import { PersistGate } from 'redux-persist/integration/react';

// ** Configs Imports
import ability from '@configs/acl/ability';
import { AbilityContext } from '@utils/context/Can';

// ** Toast & ThemeColors Context
import { ThemeContext } from '@utils/context/ThemeColors';

import Spinner from '@components/@core/spinner/Fallback-spinner';

// ** Spinner (Splash Screen)

// ** Ripple Button
import '@components/@core/ripple-button';

// ** PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss';

// ** Core styles
import '@assets/fonts/feather/iconfont.css';
import '@assets/scss/core.scss';
import '@assets/scss/style.scss';

// ** Sweet Alert
import 'animate.css/animate.css';
import '@styles/base/plugins/extensions/ext-component-sweet-alerts.scss';

// ** Service Worker
import * as serviceWorker from './serviceWorker';

// ** Lazy load app
const LazyApp = lazy(() => import('./App'));

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={<Spinner />}>
        <AbilityContext.Provider value={ability}>
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}
          >
            <ThemeContext>
              <LazyApp />
              <ToastContainer
                position='top-right'
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                newestOnTop
              />
            </ThemeContext>
          </GoogleReCaptchaProvider>
        </AbilityContext.Provider>
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
